<template>
  <div>
    <!-- : '结汇'  -->
    <baseBreadcrumb :page="$t('message.settlement')" :menu="$t('message.financial')" />
    <div class="body">
      <el-tabs v-model="datas.status" @tab-click="search" type="card">
        <el-tab-pane label="全部" name=""></el-tab-pane>
        <el-tab-pane :label="item.status_name + `(${item.count})`" name="" v-for="(item, index) in tabs" :key="index">
        </el-tab-pane>
      </el-tabs>
      <!-- 搜索 -->
      <div class="search">
        <div class="item">
          <el-date-picker v-model="createdTime" type="datetimerange" range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" start-placeholder="结汇通知开始日期"
            end-placeholder="结汇通知结束日期">
          </el-date-picker>
        </div>
        <div class="item">
          <el-date-picker v-model="notifyTime" type="datetimerange" range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" start-placeholder="结汇完成开始日期"
            end-placeholder="结汇完成结束日期">
          </el-date-picker>
        </div>
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex03">NO</li>
          <!-- 结汇编号 -->
          <li>{{ $t('message.settlementNumber') }}</li>
          <!-- 结汇金额 -->
          <li class="flex05">{{ $t('message.settlementAmount') }}</li>
          <!-- 收款人万里汇VA账户信息 -->
          <li class="flex2">{{ $t('message.payeeWiseAccountInfo') }}</li>
          <!-- 付款人万里汇VA账户信息 -->
          <li class="flex2">{{ $t('message.payerWiseAccountInfo') }}</li>
          <!-- 结汇附加信息 -->
          <li>{{ $t('message.settlementAdditionalInfo') }}</li>
          <!-- 结汇通知时间 -->
          <li>{{ $t('message.settlementNotificationTime') }}</li>
          <!-- 结汇成功时间 -->
          <li>{{ $t('message.settlementSuccessTime') }}</li>
          <!-- 结汇状态 -->
          <li class="flex05">{{ $t('message.settlementStatus') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex03">{{ item.rowNumber }}</li>
          <!-- 结汇编号 -->
          <li>
            <p>{{ item.notifyVostro.fundingId }}</p>
          </li>
          <!-- 结汇金额 -->
          <li class="flex05">
            <div class="template">
              <p>金额：{{ item.notifyVostro.balanceChangeAmount.value }}</p>
              <p>单位：{{ item.notifyVostro.balanceChangeAmount.currency }}</p>
            </div>
          </li>
          <!-- 收款人万里汇VA账户信息 -->
          <li class="flex2">
            <div class="template">
              <p>银行账户：{{ item.notifyVostro.beneficiaryAccount.accountNo }}</p>
              <p>BIC：{{ item.notifyVostro.beneficiaryAccount.bankBIC }}</p>
              <p>户主姓名：{{ item.notifyVostro.beneficiaryAccount.holderName.fullName }}</p>
            </div>
          </li>
          <!-- 付款人万里汇VA账户信息 -->
          <li class="flex2">
            <div class="template">
              <p>银行账户：{{ item.notifyVostro.payerBankAccount.accountNo }}</p>
              <p>BIC：{{ item.notifyVostro.payerBankAccount.bankBIC }}</p>
              <p>户主姓名：{{ item.notifyVostro.payerBankAccount.holderName.fullName }}</p>
              <p>户主地址：{{ item.notifyVostro.payerBankAccount.bankRegion }}</p>
              <p>银行所在的国家/地区：{{ item.notifyVostro.payerBankAccount.holderAddress }}</p>
            </div>
          </li>
          <!-- 结汇附加信息 -->
          <li>{{ item.notifyVostro.remitInfo }}</li>
          <!-- 结汇通知时间 -->
          <li>{{ item.created_at }}</li>
          <!-- 结汇成功时间 -->
          <li>{{ item.notify_at }}</li>
          <!-- 结汇状态 -->
          <li class="flex05">{{ item.status_name }}</li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [],
      createdTime: [],//结汇通知时间
      notifyTime: [],//结汇完成时间
      datas: {
        status: '',
        created_at_start: '',
        created_at_end: '',
        notify_at_start: '',
        notify_at_end: '',
        pageSize: 20,
        page: 1
      },
      total: 0,
      tableData: []
    };
  },
  created() {
    this.$api.financialApi.tradeOrderListTabNum().then(res => {
      this.tabs = res.data
    })
    this.tradeOrderList()
  },
  methods: {
    tradeOrderList() {
      // 优化时间参数处理
      const setTimeParams = (source, targetStart, targetEnd) => {
        if (source) {
          this.datas[targetStart] = source[0];
          this.datas[targetEnd] = source[1];
        } else {
          this.datas[targetStart] = '';
          this.datas[targetEnd] = '';
        }
      };
      // 处理时间参数
      setTimeParams(this.createdTime, 'created_at_start', 'created_at_end');
      setTimeParams(this.notifyTime, 'notify_at_start', 'notify_at_end');
      // 发起请求
      this.$api.financialApi.tradeOrderList(this.datas).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.tradeOrderList();
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pagesize = val;
      this.tradeOrderList();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.tradeOrderList();
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 24px;
  }
}

.table {
  margin: 24px 0;

  ol {
    position: sticky;
    top: 0;
    left: 0;
  }

  p {
    line-height: 25px;
  }

  .flex03 {
    flex: 0.3;
  }

  .flex05 {
    flex: 0.7;
  }

  .flex2 {
    flex: 2;
  }
}
</style>